/* eslint-disable max-len */
// policyAndManagementProcesses----------------------------------
export const PolicyAndManagementProcessesKey = {
  PAMP_QUESTION_1: 'pampQuestion1',
  PAMP_QUESTION_2: 'pampQuestion2',
  PAMP_QUESTION_3: 'pampQuestion3',
  PAMP_QUESTION_4: 'pampQuestion4',
  PAMP_QUESTION_5: 'pampQuestion5',
  PAMP_QUESTION_6: 'pampQuestion6',
  PAMP_QUESTION_7: 'pampQuestion7',
  PAMP_QUESTION_8: 'pampQuestion8',
  PAMP_QUESTION_9: 'pampQuestion9',
  PAMP_QUESTION_10: 'pampQuestion10',
  PAMP_QUESTION_11: 'pampQuestion11',
  PAMP_QUESTION_12: 'pampQuestion12',
  PAMP_QUESTION_13: 'pampQuestion13',
  PAMP_QUESTION_14: 'pampQuestion14',
  PAMP_QUESTION_15: 'pampQuestion15',
  PAMP_QUESTION_16: 'pampQuestion16',
  PAMP_QUESTION_17: 'pampQuestion17',
  PAMP_QUESTION_18: 'pampQuestion18',
  PAMP_QUESTION_19: 'pampQuestion19',
  PAMP_QUESTION_20: 'pampQuestion20',
  PAMP_QUESTION_21: 'pampQuestion21',
  PAMP_QUESTION_22: 'pampQuestion22',
  PAMP_QUESTION_23: 'pampQuestion23',
  PAMP_QUESTION_24: 'pampQuestion24',
  PAMP_QUESTION_25: 'pampQuestion25',
  PAMP_QUESTION_26: 'pampQuestion26',
  PAMP_QUESTION_27: 'pampQuestion27',
  PAMP_QUESTION_28: 'pampQuestion28',
  PAMP_QUESTION_29: 'pampQuestion29',
  PAMP_QUESTION_30: 'pampQuestion30',

  PAMP_QUESTION_31: 'pampQuestion31',
  PAMP_QUESTION_32: 'pampQuestion32',
  PAMP_QUESTION_33: 'pampQuestion33',
  PAMP_QUESTION_34: 'pampQuestion34',
  PAMP_QUESTION_35: 'pampQuestion35',
  PAMP_QUESTION_36: 'pampQuestion36',
  PAMP_QUESTION_37: 'pampQuestion37',
  PAMP_QUESTION_38: 'pampQuestion38',
  PAMP_QUESTION_39: 'pampQuestion39',
  PAMP_QUESTION_40: 'pampQuestion40',

  PAMP_QUESTION_41: 'pampQuestion41',
  PAMP_QUESTION_42: 'pampQuestion42',
  PAMP_QUESTION_43: 'pampQuestion43',
  PAMP_QUESTION_44: 'pampQuestion44',
  PAMP_QUESTION_45: 'pampQuestion45',
  PAMP_QUESTION_46: 'pampQuestion46',
  PAMP_QUESTION_47: 'pampQuestion47',
  PAMP_QUESTION_48: 'pampQuestion48',
  PAMP_QUESTION_49: 'pampQuestion49',
  PAMP_QUESTION_50: 'pampQuestion50',

  PAMP_QUESTION_51: 'pampQuestion51',
  PAMP_QUESTION_52: 'pampQuestion52',
  PAMP_QUESTION_53: 'pampQuestion53',
  PAMP_QUESTION_54: 'pampQuestion54',
  PAMP_QUESTION_55: 'pampQuestion55',
  PAMP_QUESTION_56: 'pampQuestion56',
  PAMP_QUESTION_57: 'pampQuestion57',
  PAMP_QUESTION_58: 'pampQuestion58',
  PAMP_QUESTION_59: 'pampQuestion59',
  PAMP_QUESTION_60: 'pampQuestion60',

  PAMP_QUESTION_61: 'pampQuestion61',
  PAMP_QUESTION_62: 'pampQuestion62',
  PAMP_QUESTION_63: 'pampQuestion63',
  PAMP_QUESTION_64: 'pampQuestion64',
  PAMP_QUESTION_65: 'pampQuestion65',
  PAMP_QUESTION_66: 'pampQuestion66',
  PAMP_QUESTION_67: 'pampQuestion67',
  PAMP_QUESTION_68: 'pampQuestion68',
  PAMP_QUESTION_69: 'pampQuestion69',
  PAMP_QUESTION_70: 'pampQuestion70',

  PAMP_QUESTION_71: 'pampQuestion71',
  PAMP_QUESTION_72: 'pampQuestion72',
  PAMP_QUESTION_73: 'pampQuestion73',
  PAMP_QUESTION_74: 'pampQuestion74',
  PAMP_QUESTION_75: 'pampQuestion75',
  PAMP_QUESTION_76: 'pampQuestion76',
  PAMP_QUESTION_77: 'pampQuestion77',
  PAMP_QUESTION_78: 'pampQuestion78',
  PAMP_QUESTION_79: 'pampQuestion79',
  PAMP_QUESTION_80: 'pampQuestion80',

  PAMP_QUESTION_81: 'pampQuestion81',
  PAMP_QUESTION_82: 'pampQuestion82',
  PAMP_QUESTION_83: 'pampQuestion83',
  PAMP_QUESTION_84: 'pampQuestion84',
  PAMP_QUESTION_85: 'pampQuestion85',
  PAMP_QUESTION_86: 'pampQuestion86',
  PAMP_QUESTION_87: 'pampQuestion87',
  PAMP_QUESTION_88: 'pampQuestion88',
  PAMP_QUESTION_89: 'pampQuestion89',
  PAMP_QUESTION_90: 'pampQuestion90'
};

export const PolicyAndManagementProcessesLabel = {
  PAMP_HEADING_1:
    '1. a. Whether your entity’s policy/policies cover each principle and its core elements of the NGRBCs. (Yes/No)',
  PAMP_HEADING_2: 'b. Has the policy been approved by the Board? (Yes/No)',
  PAMP_HEADING_3: 'c. Web Link of the Policies, if available',
  PAMP_Label_1: 'P1',
  PAMP_Label_2: 'P2',
  PAMP_Label_3: 'P3',
  PAMP_Label_4: 'P4',
  PAMP_Label_5: 'P5',
  PAMP_Label_6: 'P6',
  PAMP_Label_7: 'P7',
  PAMP_Label_8: 'P8',
  PAMP_Label_9: 'P9',
  PAMP_Label_10: ''
};

// governanceLeadershipAndOversight----------------------------------
export const GovernanceLeadershipAndOversightsKey = {
  GLAO_QUESTION_1: 'glaoQuestion1',
  GLAO_QUESTION_2: 'glaoQuestion2',
  GLAO_QUESTION_3: 'glaoQuestion3',
  GLAO_QUESTION_4: 'glaoQuestion4',
  GLAO_QUESTION_5: 'glaoQuestion5',
  GLAO_QUESTION_6: 'glaoQuestion6',
  GLAO_QUESTION_7: 'glaoQuestion7',
  GLAO_QUESTION_8: 'glaoQuestion8',
  GLAO_QUESTION_9: 'glaoQuestion9',
  GLAO_QUESTION_10: 'glaoQuestion10',

  GLAO_QUESTION_11: 'glaoQuestion11',
  GLAO_QUESTION_12: 'glaoQuestion12',
  GLAO_QUESTION_13: 'glaoQuestion13',
  GLAO_QUESTION_14: 'glaoQuestion14',
  GLAO_QUESTION_15: 'glaoQuestion15',
  GLAO_QUESTION_16: 'glaoQuestion16',
  GLAO_QUESTION_17: 'glaoQuestion17',
  GLAO_QUESTION_18: 'glaoQuestion18',
  GLAO_QUESTION_19: 'glaoQuestion19',
  GLAO_QUESTION_20: 'glaoQuestion20',

  GLAO_QUESTION_21: 'glaoQuestion21',
  GLAO_QUESTION_22: 'glaoQuestion22',
  GLAO_QUESTION_23: 'glaoQuestion23',
  GLAO_QUESTION_24: 'glaoQuestion24',
  GLAO_QUESTION_25: 'glaoQuestion25',
  GLAO_QUESTION_26: 'glaoQuestion26',
  GLAO_QUESTION_27: 'glaoQuestion27',
  GLAO_QUESTION_28: 'glaoQuestion28',
  GLAO_QUESTION_29: 'glaoQuestion29',
  GLAO_QUESTION_30: 'glaoQuestion30',

  GLAO_QUESTION_31: 'glaoQuestion31',
  GLAO_QUESTION_32: 'glaoQuestion32',
  GLAO_QUESTION_33: 'glaoQuestion33',
  GLAO_QUESTION_34: 'glaoQuestion34',
  GLAO_QUESTION_35: 'glaoQuestion35',
  GLAO_QUESTION_36: 'glaoQuestion36',
  GLAO_QUESTION_37: 'glaoQuestion37',
  GLAO_QUESTION_38: 'glaoQuestion38',
  GLAO_QUESTION_39: 'glaoQuestion39',
  GLAO_QUESTION_40: 'glaoQuestion40',

  GLAO_QUESTION_41: 'glaoQuestion41',
  GLAO_QUESTION_42: 'glaoQuestion42',
  GLAO_QUESTION_43: 'glaoQuestion43',
  GLAO_QUESTION_44: 'glaoQuestion44',
  GLAO_QUESTION_45: 'glaoQuestion45',
  GLAO_QUESTION_46: 'glaoQuestion46',
  GLAO_QUESTION_47: 'glaoQuestion47',
  GLAO_QUESTION_48: 'glaoQuestion48',
  GLAO_QUESTION_49: 'glaoQuestion49',
  GLAO_QUESTION_50: 'glaoQuestion50',

  GLAO_QUESTION_51: 'glaoQuestion51',
  GLAO_QUESTION_52: 'glaoQuestion52',
  GLAO_QUESTION_53: 'glaoQuestion53',
  GLAO_QUESTION_54: 'glaoQuestion54',
  GLAO_QUESTION_55: 'glaoQuestion55',
  GLAO_QUESTION_56: 'glaoQuestion56',
  GLAO_QUESTION_57: 'glaoQuestion57',
  GLAO_QUESTION_58: 'glaoQuestion58',
  GLAO_QUESTION_59: 'glaoQuestion59',
  GLAO_QUESTION_60: 'glaoQuestion60',

  GLAO_QUESTION_61: 'glaoQuestion61',
  GLAO_QUESTION_62: 'glaoQuestion62',
  GLAO_QUESTION_63: 'glaoQuestion63',
  GLAO_QUESTION_64: 'glaoQuestion64',
  GLAO_QUESTION_65: 'glaoQuestion65',
  GLAO_QUESTION_66: 'glaoQuestion66',
  GLAO_QUESTION_67: 'glaoQuestion67',
  GLAO_QUESTION_68: 'glaoQuestion68',
  GLAO_QUESTION_69: 'glaoQuestion69',
  GLAO_QUESTION_70: 'glaoQuestion70'
};

export const GovernanceLeadershipAndOversightLabel = {
  GLAO_HEADING_1:
    'a. Subject for Review (Performance against above policies and follow up action)',
  GLAO_HEADING_2:
    'b. Subject for Review (Compliance with statutory requirements of relevance to the principles, and, rectification of any non-compliances)',
  GLAO_HEADING_3:
    'Indicate whether review was undertaken by Director / Committee of the Board/Any other Committee',
  GLAO_HEADING_4:
    'Frequency (Annually / Half yearly / Quarterly / Any other – please specify)',
  GLAO_HEADING_5:
    'The entity does not consider the Principles material to its business (Yes/No)',
  GLAO_HEADING_6:
    'The entity is not at a stage where it is in a position to formulate and implement the policies on specified principles (Yes/No)',
  GLAO_HEADING_7:
    'The entity does not have the financial or/human and technical resources available for the task (Yes/No)',
  GLAO_HEADING_8:
    'It is planned to be done in the next financial year (Yes/No)',
  GLAO_HEADING_9: 'Any other reason (please specify)',
  GLAO_Label_1: 'P1',
  GLAO_Label_2: 'P2',
  GLAO_Label_3: 'P3',
  GLAO_Label_4: 'P4',
  GLAO_Label_5: 'P5',
  GLAO_Label_6: 'P6',
  GLAO_Label_7: 'P7',
  GLAO_Label_8: 'P8',
  GLAO_Label_9: 'P9',
  GLAO_Label_10: ''
};
